import { instance } from "libs/api";

import { InventoryManagerListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";
import { CreateInventoryManagerRequestBody } from "./createInventoryManager.types";

export const requestCreateInventoryManager = async (
  body: CreateInventoryManagerRequestBody
): Promise<InventoryManagerListItem> => {
  return await instance.post(ApiRoutesInventory.InventoryManager, body);
};
